import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AlertComponent } from './alerts/alerts.component';
import { AlertResolver } from './alerts.resolver';
import { AlertService } from './alerts.service';
import { APP_INITIALIZER } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ContainerResolver } from './container.resolver';
import { ContainerSelectorComponent } from './container-selector/container-selector.component';
import { ContainerService } from './container.service';
import { DebugComponent } from './debug/debug.component';
import { DescriptionsModule } from './descriptions/descriptions.module';
import { ErrorComponent } from './errors/error.component';
import { FeatureFlagsService } from './feature-flags.service';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { HealthComponent } from './health/health.component';
import { Help_GuideComponent } from './help_guides/help_guides.component';
import { LaunchComponent } from './home/launch.component';
import { NgModule, ErrorHandler } from '@angular/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SchoolBannerComponent } from './school-banner/school-banner.component';
import { SecondsToDatetimePipe } from './seconds-to-datetime.pipe';
import { SentryErrorHandler } from './sentry-error-handler';
import { ServerResolver } from './server.resolver';
import { TokenInterceptor } from './utils/token.interceptor';
import { UserGuard } from './user.guard';
import { UserResolver } from './user.resolver';
import { UserService } from './user.service';
import * as Sentry from '@sentry/browser';
import { CollabContainerPipe } from './container-selector/collab-container.pipe';
import { UsageReportingService } from './usage-reporting/usage-reporting.service';
import { UsageReportingResolver } from './usage-reporting/usage-reporting.resolver';

Sentry.init({
  dsn: 'https://4ca55d80075745838dca5d3e6794eae9@sentry.edina.ac.uk/3',
  environment: window.location.host,
});

@NgModule({
  declarations: [
    AlertComponent,
    AppComponent,
    ContainerSelectorComponent,
    DebugComponent,
    ErrorComponent,
    HeaderComponent,
    HealthComponent,
    Help_GuideComponent,
    FooterComponent,
    LaunchComponent,
    SchoolBannerComponent,
    SecondsToDatetimePipe,
    CollabContainerPipe,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    ClipboardModule,
    DescriptionsModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    AlertResolver,
    AlertService,
    ContainerService,
    ContainerResolver,
    FeatureFlagsService,
    ServerResolver,
    UserGuard,
    UserService,
    UserResolver,
    UsageReportingService,
    UsageReportingResolver,
    {
      provide: APP_INITIALIZER,
      useFactory: (featureFlagsService: FeatureFlagsService) => () => featureFlagsService.loadFeatureFlags(),
      deps: [FeatureFlagsService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
